<template>
  <div id="recruit" class="body">
    <Top />

    <div role="main" class="main">
      <section class="page-header page-header-classic page-header-sm">
        <div class="container">
          <div class="row">
            <div class="col-md-8 order-2 order-md-1 align-self-center p-static">
              <h1 data-title-border>採用情報</h1>
            </div>
            <div class="col-md-4 order-1 order-md-2 align-self-center">
              <ul class="breadcrumb d-block text-md-right">
                <li><router-link to="/index">Home</router-link></li>
                <li class="active">採用情報</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="hero recruit-hero">
        <div class="hero-content">
          <p class="hero-tag">JOIN OUR TEAM</p>
          <h1>チャレンジできるフィールド</h1>
          <p>
            チャレンジできるフィールドを多数ご用意しております。以下エントリーボタンより、皆様のご応募をお待ちしております。
          </p>
        </div>
      </section>

      <section class="grid-cards recruit-cards">
        <article class="tech-card">
          <h3>システムエンジニア</h3>
          <p>求む技術志向エンジニア！！</p>
          <p>
            要件定義・設計・コーディングなど上流工程から実装工程までスキルに応じて、幅広い業務にチャレンジしていただきます。
            スキルアップを目指せるプロジェクトに配属し、ご活躍していただきます。
          </p>
          <button class="btn-tech">募集要項確認</button>
        </article>

        <article class="tech-card">
          <h3>インフラエンジニア</h3>
          <p>初心者歓迎！求むチームリーダー！</p>
          <p>
            弊社が得意とするシステム開発をインフラエンジニアの観点からソフトウェアアーキテクチャの提案、
            新たなクラウドソリューションの導入を積極的に提案していただけるポジションとなります。
          </p>
          <button class="btn-tech">募集要項確認</button>
        </article>

        <article class="tech-card">
          <h3>ソフトウェア開発エンジニア</h3>
          <p>高報酬案件を多数ご用意！！</p>
          <p>
            会社の持続発展に資するため、豊富なキャリアアップ研修コースを設けています。
            語学、品質意識、管理手法、開発プロセスなど多方面で能力研鑽を促します。
          </p>
          <button class="btn-tech">募集要項確認</button>
        </article>
      </section>

      <section class="container py-4">
        <div class="policy p-3">
          <h3>エントリーに関する同意</h3>
          <p>以下の「個人情報の取り扱い」をご確認していただき「同意して進む」ボタンよりお問い合わせください。</p>
          <div class="consent">
            <pre>
このフォームで頂戴する個人情報の取り扱いについて
1. 事業者の氏名又は名称
イノソース株式会社

2. 個人情報保護管理者（若しくはその代理人）の氏名又は職名、
所属及び連絡先
所属部署：ITソリューション事業部　マネージャー
氏名 :
連絡先：メールアドレス：info@innosource.co.jp

3. 個人情報の利用目的
採用応募者の個人情報は、弊社の人事採用活動（書類審査、
面接、評価、応募者への連絡等）のために利用いたします。

4. 個人情報の第三者への提供
業務担当者又は担当候補者の紹介のために、氏名、所属、
業務経歴書を、直接持参するか電子メール添付(パスワード付)で、
当社取引先に提供します。

5.個人情報取扱いの委託
当社は事業運営上、前項利用目的の範囲に限って個人情報を
外部に委託することがあります。この場合、個人情報保護水準の
高い委託先を選定し、個人情報の適正管理・機密保持について
の契約を交わし、適切な管理を実施させます。

6. 個人情報の開示等の請求
ご本人様は、当社に対してご自身の個人情報の開示等に関して、
下記の当社問合わせ窓口に申し出ることができます。

【お問合せ窓口】
イノソース株式会社 個人情報問合せ窓口
〒850-0035 長崎県長崎市元船町9-18 2階
メールアドレス：info@innosource.co.jp

7. 個人情報を提供されることの任意性について
ご本人様が当社に個人情報を提供されるかどうかは任意によるものです。
            </pre>
          </div>
        </div>
      </section>
    </div>

    <Foot />
  </div>
</template>

<script>
import Top from '@/components/top';
import Foot from '@/components/foot';

export default {
  name: 'recruit',
  components: {
    Top,
    Foot,
  },
};
</script>

<style scoped>
.recruit-hero {
  margin-bottom: 1.2rem;
}

.recruit-cards {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.recruit-cards .btn-tech {
  margin-top: 0.8rem;
  cursor: pointer;
}

@media (max-width: 1024px) {
  .recruit-cards {
    grid-template-columns: 1fr;
  }
}
</style>
